import { filterInterface } from '@ardoq/filter-interface';
import { ComponentLabelSource, ReferenceLabelSource } from '@ardoq/data-model';
import { APIFieldAttributes } from '@ardoq/api-types';
import { dateRangeOperations, isDateRangeFieldType } from '@ardoq/date-range';
import { sortBy, uniqBy } from 'lodash';
import type { PerspectivesFormattingOptions } from '@ardoq/perspectives-sidebar';

export const getAppliedReferenceFormattingLabelData = (): Pick<
  PerspectivesFormattingOptions,
  'appliedReferenceFormattingLabel' | 'isAppliedReferenceLabelTimeIncluded'
> => {
  const referenceLabelFilter = filterInterface.getReferenceLabelFilter();
  return {
    appliedReferenceFormattingLabel:
      referenceLabelFilter.value ??
      ReferenceLabelSource.DISPLAY_TEXT_OR_REFERENCE_TYPE,
    isAppliedReferenceLabelTimeIncluded:
      referenceLabelFilter.includeTime ?? false,
  };
};

export const getAppliedComponentFormattingLabelData = (): Pick<
  PerspectivesFormattingOptions,
  'appliedComponentFormattingLabel' | 'isAppliedComponentLabelTimeIncluded'
> => {
  const componentLabelFormattingFields =
    filterInterface.getComponentLabelFormattingFields();
  const [firstComponentLabelFormattingField] = componentLabelFormattingFields;
  const appliedComponentFormattingLabel =
    firstComponentLabelFormattingField ?? ComponentLabelSource.NAME;

  return {
    appliedComponentFormattingLabel,
    isAppliedComponentLabelTimeIncluded:
      filterInterface.getComponentLabelFilter().includeTime ?? false,
  };
};
export const getFormattingCustomLabelsByFields = (
  fields: APIFieldAttributes[]
) =>
  sortBy(
    uniqBy(
      dateRangeOperations.mergeDateTimeFieldsToDateRangeFields(
        fields as APIFieldAttributes[]
      ).fields,
      'name'
    ),
    'name'
  ).flatMap(field =>
    isDateRangeFieldType(field.type)
      ? dateRangeOperations.splitDateRangeFieldIntoStartAndEndSelectOptions(
          field
        )
      : toCustomLabelFormattingOption(field)
  );

export const getReferenceFormattingCustomLabels = (
  allWorkspaceFields: APIFieldAttributes[]
) =>
  getFormattingCustomLabelsByFields(
    allWorkspaceFields.filter(field =>
      Boolean(field.globalref || field.referenceType.length)
    )
  );

export const getComponentFormattingCustomLabels = (
  allWorkspaceFields: APIFieldAttributes[]
) =>
  getFormattingCustomLabelsByFields(
    allWorkspaceFields.filter(field =>
      Boolean(field.global || field.componentType.length)
    )
  );

export const toCustomLabelFormattingOption = (
  field: NameAndLabelAttributes
) => ({
  value: field.name,
  label: field.label,
});

type NameAndLabelAttributes = {
  name: string;
  label: string;
};
